import { useTranslation } from "react-i18next";
import type { Locale } from "common/models/settings/Settings";

export default function useLocale() {
    const { i18n } = useTranslation();
    return i18n.language as Locale;
}
